<template>
  <div>
    <div>
      <div class="container">
        <Search
          :data="searchData"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          :count="count"
          @handleFocus="handleFocus"
          @handleFilter="handleSearch"
          @handleReset="resetList"
        />
      </div>

      <div class="container">
        <!-- <div class="tip">注：报价状态筛选项仅对导出供应商报价信息生效</div> -->
        <div class="handle-wrapper">
          <eui-btn type="secondary" class="margin-r10" @click="handleExport(0)">导出询价单信息</eui-btn>
          <eui-btn type="secondary" class="margin-r10" @click="handleExport(1)">导出询价单商品清单</eui-btn>
          <eui-btn type="secondary" class="margin-r10" @click="handleExport(2)">导出供应商报价信息</eui-btn>
          <eui-btn type="secondary" @click="handleExport(3)">导出供应商报价商品清单</eui-btn>
        </div>
        <tableList :loading="false" :table-data="tableData" :table-label="tableLabel">
          <template #createModeStr="{ scope: { row } }">
            <span>{{ getCreateModeArr(row.createMode) }}</span>
          </template>
          <template #createSourceStr="{ scope: { row } }">
            <span>{{ getCreateSourceArr(row.createMode) }}</span>
          </template>

          <template #offerCount="{ scope: { row } }">
            <eui-link lighten font-size="12" @click="goDetail(row, 1)">
              {{ row.offerCount }}
            </eui-link>
          </template>
          <template #shipmentType="{ scope: { row } }">
            <span>{{ formatShipmentType(row.shipmentType) }}</span>
          </template>
          <template #operation="{ scope: { row } }">
            <eui-link lighten font-size="12" @click="goDetail(row, 2)">商品详情</eui-link>
            <eui-link
              v-if="row.enquiryStatus == 5 || row.enquiryStatus == 6 || row.enquiryStatus == 7"
              style="margin-left: 10px"
              font-size="12"
              lighten
              @click="goDetail(row, 3)"
            >
              报价详情
            </eui-link>
          </template>
        </tableList>
        <div class="pagination">
          <el-pagination
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="listQuery.pageNum"
            :page-size="listQuery.pageSize"
            :total="total"
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>

    <EDialog
      dialog-title="定向询价供应商"
      :center-dialog-visible="supplier.dialogVisible"
      destroy-close
      :show-btn="false"
      show-close-btn
      modal-append-to-body
      popup-width="880px"
      @resetPopupData="supplier.dialogVisible = false"
    >
      <tableList :table-data="supplier.list" :table-label="supplier.tableLabel">
        <template #index="{ scope }">
          <span>{{ (supplier.pageNum - 1) * supplier.pageSize + scope.$index + 1 }}</span>
        </template>
      </tableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[5, 10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="supplier.pageNum"
          :page-size="supplier.pageSize"
          :total="supplier.total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="supplierSizeChange"
          @current-change="supplierCurrentChange"
        ></el-pagination>
      </div>
    </EDialog>

    <EDialog
      dialog-title="商品信息"
      :center-dialog-visible="queryEnquiry.dialogVisible"
      destroy-close
      :show-btn="false"
      show-close-btn
      modal-append-to-body
      popup-width="1000px"
      @resetPopupData="queryEnquiry.dialogVisible = false"
    >
      <tableList :table-data="queryEnquiry.list" :table-label="queryEnquiry.tableLabel"></tableList>
      <!-- <el-table :data="queryEnquiry.list">
        <el-table-column property="enquiryName" label="询价单名称" width="150"></el-table-column>
        <el-table-column property="enquiryNo" label="询价单号" width="150"></el-table-column>
        <el-table-column property="productName" label="商品名称"></el-table-column>
        <el-table-column property="brandName" label="品牌名称"></el-table-column>
        <el-table-column property="requiredQuantity" label="需求数量"></el-table-column>
        <el-table-column property="unitName" label="计量单位"></el-table-column>
        <el-table-column property="specifications" label="规格型号"></el-table-column>
      </el-table> -->
      <div class="pagination">
        <el-pagination
          :page-sizes="[5, 10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryEnquiry.pageNum"
          :page-size="queryEnquiry.pageSize"
          :total="queryEnquiry.total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="queryEnquirySizeChange"
          @current-change="queryEnquiryCurrentChange"
        ></el-pagination>
      </div>
    </EDialog>

    <EDialog
      :dialog-title="supplierQuery.supplierDialogTitle"
      :center-dialog-visible="supplierQuery.supplierDialogVisible"
      destroy-close
      :show-btn="false"
      show-close-btn
      modal-append-to-body
      popup-width="1000px"
      @resetPopupData="supplierQuery.supplierDialogVisible = false"
    >
      <!-- <el-table ref="table2" :data="supplierQuery.list">
        <el-table-column property="supplierCompany" label="供应商名称"></el-table-column>
        <el-table-column property="offerAmount" label="报价单总价" width="150"></el-table-column>
        <el-table-column property="quotationValidity" label="报价有效期"></el-table-column>
        <el-table-column property="quotationDeadline" label="报价截止日期"></el-table-column>
        <el-table-column property="offerRealName" label="联系人"></el-table-column>
        <el-table-column property="offerMobile" label="联系方式"></el-table-column>
        <el-table-column property="offerEmail" label="邮箱"></el-table-column>
        <el-table-column label="报价状态" min-width="110" align="center">
          <template #default="scope">
            <span>
              {{ offerStatusEN(scope.row.offerStatus) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100" align="center">
          <template #default="scope">
            <eui-btn size="12" type="text" @click="getProductDetail(scope.row)">查看详情</eui-btn>
          </template>
        </el-table-column>
      </el-table> -->
      <tableList :table-data="supplierQuery.list" :table-label="supplierQuery.tableLabel">
        <template #offerStatus="{ scope }">
          <span>{{ offerStatusEN(scope.row.offerStatus) }}</span>
        </template>
        <template #operation="{ scope }">
          <eui-link lighten font-size="12" @click="getProductDetail(scope.row)">查看详情</eui-link>
        </template>
      </tableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[5, 10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="supplierQuery.pageNum"
          :page-size="supplierQuery.pageSize"
          :total="supplierQuery.total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="supplierQuerySizeChange"
          @current-change="supplierQueryCurrentChange"
        ></el-pagination>
      </div>
    </EDialog>

    <EDialog
      dialog-title="供应商报价商品信息"
      :center-dialog-visible="productQuery.productDialogVisible"
      destroy-close
      :show-btn="false"
      show-close-btn
      modal-append-to-body
      popup-width="1000px"
      @resetPopupData="productQuery.productDialogVisible = false"
    >
      <tableList :table-data="productQuery.list" :table-label="productQuery.tableLabel"></tableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[5, 10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productQuery.pageNum"
          :page-size="productQuery.pageSize"
          :total="productQuery.total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="productSizeChange"
          @current-change="productCurrentChange"
        ></el-pagination>
      </div>
    </EDialog>

    <!--采购商 和 供应商  的 弹框-->
    <query-name-dialog
      v-if="chooseVisible"
      :choose-visible="chooseVisible"
      :company-id-list="companyIdList"
      :purchase-company-info="purchaseCompanyInfo"
      :purchase-company-id-list="searchData.purchaseCompanyIdList"
      :supplier-company-info="supplierCompanyInfo"
      :supplier-company-id-list="searchData.supplierCompanyIdList"
      :select-name-flag="selectNameFlag"
      @closeDialog="closeDialog"
      @handleQueryCompany="handleQueryCompany"
    />
    <!-- 采购商弹框-->
    <query-purchase-company-dialog
      v-if="queryPurchaseCompanyVisible"
      :queryPurchaseCompanyVisible.sync="queryPurchaseCompanyVisible"
      :purchase-company-info="purchaseCompanyInfo"
      @confirmPurchaseCompany="confirmPurchaseCompany"
    />
  </div>
</template>

<script>
import axios from 'more-request/instance';
import EDialog from '@/modules/projectA/components/common/e-dialog';
import Search from '@/modules/projectA/components/common/e-search';
import TableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/enquiry';
import utils from '@/modules/projectA/utils/utils.js';
import queryNameDialog from '@/modules/projectA/pages/orderReport/common/queryNameDialog';
import queryPurchaseCompanyDialog from '../orderReport/common/queryPurchaseCompanyDialog';

const enquiryStatusArr = [
  { value: 0, label: '已保存' },
  { value: 1, label: '待审核' },
  { value: 2, label: '待报价' },
  { value: 3, label: '待揭示' },
  { value: 4, label: '已揭示' },
  { value: 5, label: '询价完成' },
  // { value: 6, label: "已下单"},
  { value: 7, label: '订单完成' },
  { value: 8, label: '询价作废' },
  { value: 9, label: '审核拒绝' },
  { value: 10, label: '询价过期' },
  { value: 14, label: '中选通知待确认' },
];
const enquiryTypeArr = [
  {
    value: 0,
    label: '定向询价',
  },
  {
    value: 1,
    label: '公开询价',
  },
];
export default {
  components: {
    EDialog,
    Search,
    TableList,
    queryNameDialog,
    queryPurchaseCompanyDialog,
  },
  data() {
    return {
      queryPurchaseCompanyVisible: false,
      addSupplierVisible: true,
      count: 6,
      searchData: {
        enquiryNo: null,
        enquiryName: null,
        enquiryType: null,
        purchaseCompany: null,
        productName: null,
        enquiryStatusList: null,
        createMode: null,
        createSource: null,
        dataFrom: null,
        isDoC: null,
        shipmentType: null,
        createTime: null,
        inquiryCompletedTime: null,
        supplierCompanyIdList: null,
        purchaseCompanyIdList: null,
        // offerStatusList: [],
      },
      fieldList: [
        { label: '询价单号', type: 'input', value: 'enquiryNo' },
        { label: '询价单名称', type: 'input', value: 'enquiryName' },
        {
          label: '询价类型',
          type: 'select',
          value: 'enquiryType',
          list: 'enquiryTypeArr',
        },
        /* { label: '采购商', type: 'input', value: 'purchaseCompany' }, */
        {
          label: '采购商',
          type: 'dialog',
          value: 'purchaseCompanyIdList',
          placeholder: '请输入采购商',
        },
        { label: '商品名称', type: 'input', value: 'productName' },
        {
          label: '询价状态',
          type: 'select',
          value: 'enquiryStatusList',
          list: 'enquiryStatusArr',
          multiple: 'multiple',
          collapseTags: true,
        },
        {
          label: '业务场景',
          type: 'select',
          value: 'createMode',
          list: 'createModeArr',
        },
        {
          label: '询价来源',
          type: 'select',
          value: 'createSource',
          list: 'createSourceArr',
        },
        {
          label: '数据来源',
          type: 'select',
          value: 'dataFrom',
          list: 'dataFromArr',
        },
        {
          label: '结算方式',
          type: 'select',
          value: 'isDoC',
          list: 'payTypeOptions',
        },
        {
          label: '配送方式',
          type: 'select',
          value: 'shipmentType',
          list: 'shipmentTypeOptions',
        },
        {
          label: '创建时间',
          type: 'date',
          dateType: 'daterange',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd',
        },
        {
          label: '询价完成时间',
          type: 'date',
          dateType: 'datetimerange',
          value: 'inquiryCompletedTime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
        },
        /* {
          label: '报价状态',
          type: 'select',
          value: 'offerStatusList',
          list: 'offerStatusList',
          multiple: 'multiple',
          collapseTags: true,
          labelTooltip: true,
          labelTooltipContent: '报价状态筛选项仅对导出供应商报价信息生效',
        }, */
      ],
      listTypeInfo: {
        enquiryTypeArr: [
          { id: null, name: '全部' },
          { id: 0, name: '定向询价' },
          { id: 1, name: '公开询价' },
        ],
        enquiryStatusArr: [
          { id: null, name: '全部' },
          { id: 0, name: '已保存' },
          { id: 1, name: '待审核' },
          { id: 2, name: '待报价' },
          { id: 3, name: '待揭示' },
          { id: 4, name: '已揭示' },
          { id: 5, name: '询价完成' },
          // { value: 6, label: "已下单"},
          { id: 7, name: '订单完成' },
          { id: 8, name: '询价作废' },
          { id: 9, name: '审核拒绝' },
          { id: 10, name: '询价过期' },
          { id: 14, name: '中选通知待确认' },
        ],
        createModeArr: [
          { id: null, name: '全部' },
          { id: 0, name: '用户创建' },
          { id: 1, name: '第三方集成' },
          { id: 2, name: '采购申请（一体化）' },
          { id: 3, name: '采购需求' },
          { id: 5, name: '易应急询价' },
          { id: 6, name: '应急需求' },
        ],
        createSourceArr: [
          { id: null, name: '全部' },
          { id: 0, name: '易派客2.0' },
          { id: 1, name: '盐湖' },
          { id: 2, name: 'EC' },
        ],
        dataFromArr: [
          { id: null, name: '全部' },
          { id: 0, name: 'PC端' },
          { id: 1, name: '小程序' },
        ],
        payTypeOptions: [
          { id: null, name: '全部' },
          { name: '款到发货', id: 0 },
          { name: '货到付款', id: 1 },
        ],
        shipmentTypeOptions: [
          { id: null, name: '全部' },
          { name: '卖家自行配送', id: 1 },
          { name: '第三方物流', id: 3 },
        ],
        /* offerStatusList: [
          // { id: null, name: '全部' },
          { id: 0, name: '待报价' },
          { id: 1, name: '已报价' },
          { id: 2, name: '已入选' },
          { id: 3, name: '未入选' },
          { id: 4, name: '询价过期' },
          { id: 5, name: '询价作废' },
          { id: 6, name: '磋商中' },
          { id: 7, name: '入选待确认' },
        ], */
      },
      // 询价来源、订单号、订单金额、是否在线支付、易全通支付金额、浏览次数、是否删除
      tableLabel: [
        {
          label: '询价单号',
          param: 'enquiryNo',
          align: 'center',
          width: '160px',
        },
        {
          label: '询价单名称',
          param: 'enquiryName',
          width: '120px',
          align: 'center',
        },
        {
          label: '询价类型',
          param: 'enquiryTypeName',
          width: '120px',
          align: 'center',
        },
        {
          label: '业务场景',
          slot: 'createModeStr',
          width: '120px',
          align: 'center',
        },
        /* {
          label: '询价来源',
          slot: 'createSourceStr',
          width: '120px',
          align: 'center',
        }, */
        {
          label: '数据来源',
          param: 'dataFromDesc',
          align: 'center',
          width: '120px',
        },
        {
          label: '询价状态',
          param: 'enquiryStatusName',
          width: '120px',
          align: 'center',
        },
        {
          label: '采购商名称',
          param: 'purchaseCompany',
          width: '180px',
          align: 'center',
        },
        {
          label: '结算方式',
          render(row) {
            return row.isDoC !== undefined ? (row.isDoC === 1 ? '货到付款' : '款到发货') : '';
          },
          width: '120px',
          align: 'center',
        },
        {
          label: '配送方式',
          slot: 'shipmentType',
          align: 'center',
          width: '120px',
        },
        {
          label: '报价限额(元)',
          param: 'quotationLimit',
          align: 'center',
          width: '120px',
        },
        {
          label: '报价开始时间',
          param: 'releaseTime',
          width: '150px',
          align: 'center',
        },
        {
          label: '报价截止日期',
          param: 'quotationDeadline',
          width: '150px',
          align: 'center',
        },
        {
          label: '要求到货日期',
          param: 'arrivalTime',
          width: '150px',
          align: 'center',
        },
        {
          label: '创建时间',
          param: 'createTime',
          width: '150px',
          align: 'center',
        },
        {
          label: '询价完成时间',
          param: 'inquiryCompletedTime',
          width: '150px',
          align: 'center',
        },
        {
          label: '订单创建时间',
          param: 'createOrderTimeDesc',
          width: '150px',
          align: 'center',
        },
        {
          label: '创建人',
          param: 'createMemberName',
          width: '134px',
          align: 'center',
        },
        {
          label: '是否含运费',
          param: 'includeFreightName',
          width: '134px',
          align: 'center',
        },
        {
          label: '收货人',
          param: 'realName',
          width: '134px',
          align: 'center',
        },
        {
          label: '收货地址',
          param: 'address',
          width: '134px',
          align: 'center',
        },
        {
          label: '采购商联系方式',
          param: 'mobile',
          width: '134px',
          align: 'center',
        },
        {
          label: '供应商名称',
          param: 'supplierCompany',
          align: 'center',
          width: '150px',
        },
        {
          label: '供应商联系人',
          param: 'suppConfirmName',
          align: 'center',
          width: '150px',
        },
        /* {
          label: '订单号',
          param: 'orderNo',
          width: '130px',
          align: 'center',
        }, */
        /* {
          label: '订单金额',
          param: 'needPay',
          align: 'center',
        }, */
        /* {
          label: '发票类型',
          param: 'electronicInvoiceFlag',
          align: 'center',
          render: (item) => {
            let str = '';
            if (parseInt(item.electronicInvoiceFlag, 10) === 1) {
              str = '电子发票';
            } else {
              str = '纸质发票';
            }
            return str;
          },
        }, */
        /* {
          label: '是否在线支付',
          param: 'isOnLinePayName',
          align: 'center',
          width: '100px',
        }, */
        /* {
          label: '易权通支付金额',
          param: 'otherNeedPay',
          align: 'center',
          width: '110px',
        },
        {
          label: '浏览次数',
          param: 'pageView',
          width: '110px',
          align: 'center',
        },
        {
          label: '是否删除',
          render(row) {
            return row.deleteSign === 1 ? '是' : '';
          },
          width: '100px',
          align: 'center',
        }, */
        {
          label: '定向询价供应商数量',
          slot: 'offerCount',
          width: '110px',
          align: 'center',
        },
        {
          label: '操作',
          align: 'center',
          width: '160px',
          slot: 'operation',
          fixed: 'right',
        },
      ],
      // 不能删除
      createModeArr: [
        {
          value: null,
          label: '全部',
        },

        {
          value: 0,
          label: '用户创建',
        },
        {
          value: 1,
          label: '第三方集成',
        },
        {
          value: 2,
          label: '采购申请（一体化）',
        },
        {
          value: 3,
          label: '采购需求',
        },
        {
          value: 4,
          label: '采购计划',
        },
        { value: 5, label: '易应急询价' },
        { value: 6, label: '应急需求' },
      ],
      // 询价来源 不能删除
      createSourceArr: [
        {
          value: null,
          label: '全部',
        },
        {
          value: 0,
          label: '易派客2.0',
        },
        {
          value: 1,
          label: '盐湖',
        },
        {
          value: 2,
          label: 'EC',
        },
      ],
      enquiryTypeArr,
      enquiryStatusArr,
      listQuery: {
        enquiryNo: null,
        enquiryName: null,
        enquiryType: null,
        dataFrom: null,
        purchaseCompany: null,
        // productName: null,
        purchaseCompanyIdList: null,
        enquiryStatusList: [],
        createTime: [],
        inquiryCompletedTime: [],
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
        isDoC: null,
        shipmentType: null,
        supplierCompanyIdList: null,
      },
      total: 0,
      tableData: [],

      form: {},

      loading: false,
      dialogVisible: false,
      supplierDataList: [],

      supplierQuery: {
        tableLabel: [
          {
            label: '供应商名称',
            param: 'supplierCompany',
            width: '180px',
            align: 'center',
          },
          {
            label: '报价单总价',
            param: 'offerAmount',
            width: '110px',
            align: 'center',
          },
          {
            label: '报价有效期',
            param: 'quotationValidity',
            width: '150px',
            align: 'center',
          },
          {
            label: '报价截止日期',
            param: 'quotationDeadline',
            width: '150px',
            align: 'center',
          },
          {
            label: '联系人',
            param: 'offerRealName',
            width: '110px',
            align: 'center',
          },
          {
            label: '联系方式',
            param: 'offerMobile',
            width: '110px',
            align: 'center',
          },
          {
            label: '邮箱',
            param: 'offerEmail',
            width: '150px',
            align: 'center',
          },
          {
            label: '报价状态',
            slot: 'offerStatus',
            width: '110px',
            align: 'center',
          },
          {
            label: '操作',
            align: 'center',
            width: '140px',
            slot: 'operation',
            fixed: 'right',
          },
        ],
        supplierDialogTitle: '',
        supplierDialogVisible: false,
        list: [],

        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      productQuery: {
        tableLabel: [
          {
            label: '商品名称',
            param: 'productName',
            mingWidth: '260px',
            align: 'center',
          },
          {
            label: '品牌',
            param: 'brandName',
            width: '130px',
            align: 'center',
          },
          {
            label: '规格型号',
            param: 'specifications',
            width: '260px',
            align: 'center',
          },
          {
            label: '商品描述',
            param: 'productDescription',
            width: '150px',
            align: 'center',
          },
          {
            label: '需求数量',
            param: 'requiredQuantity',
            width: '110px',
            align: 'center',
          },
          {
            label: '计量单位',
            param: 'unitName',
            width: '110px',
            align: 'center',
          },
          {
            label: '报价单价(含税)',
            param: 'offerEmail',
            width: '150px',
            align: 'center',
          },
          {
            label: '税率(%)',
            param: 'taxRate',
            width: '110px',
            align: 'center',
          },
          {
            label: '运费(元)',
            param: 'deliveryFee',
            width: '110px',
            align: 'center',
          },
          {
            label: '小计',
            param: 'totalPrice',
            width: '80px',
            align: 'center',
          },
        ],
        enquiryId: '',
        supplierOfferId: '',
        productDialogVisible: false,
        list: [],
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      supplier: {
        tableLabel: [
          {
            label: '序号',
            slot: 'index',
            align: 'center',
            width: '80px',
          },
          {
            label: '供应商名称',
            param: 'supplierCompany',
            align: 'center',
          },
        ],
        dialogVisible: false,
        list: [],
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      queryEnquiry: {
        tableLabel: [
          {
            label: '询价单名称',
            param: 'enquiryName',
            width: '150px',
            align: 'center',
          },
          {
            label: '询价单号',
            param: 'enquiryNo',
            width: '150px',
            align: 'center',
          },
          {
            label: '商品名称',
            param: 'productName',
            minWidth: '150px',
            align: 'center',
          },
          {
            label: '品牌名称',
            param: 'brandName',
            width: '150px',
            align: 'center',
          },
          {
            label: '需求数量',
            param: 'requiredQuantity',
            width: '100px',
            align: 'center',
          },
          {
            label: '计量单位',
            param: 'unitName',
            align: 'center',
          },
          {
            label: '规格型号',
            param: 'specifications',
            width: '150px',
            align: 'center',
          },
        ],
        dialogVisible: false,
        list: [],
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      rowInfo: {},
      chooseVisible: false, // 采购商和供应商选择的弹框
      selectNameFlag: '', // 区别 是 采购商 还是 供应商的 字段
      companyIdList: [], // 采购商 或者 供应商默认选中得id集合
      purchaseCompanyInfo: [], // 采购商默认选中 的所有信息
      supplierCompanyInfo: [], // 供应商默认选中 的所有信息
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    confirmPurchaseCompany(val) {
      let companyNameList = val.map((item) => item.companyName).toString();
      if (companyNameList && companyNameList.length > 15) {
        companyNameList = `${companyNameList.substring(0, 14)}...`;
      }
      this.companyIdList = val.map((item) => item.companyId);
      if (companyNameList.length > 0) {
        this.searchData.purchaseCompanyIdList = companyNameList;
        this.listQuery.purchaseCompanyIdList = this.companyIdList;
        this.purchaseCompanyInfo = val;
      } else {
        this.searchData.purchaseCompanyIdList = null;
        this.listQuery.purchaseCompanyIdList = null;
        this.purchaseCompanyInfo = [];
      }
    },
    // 采购商 和 供应商 的 多选
    handleQueryCompany(val) {
      console.log(val, this.selectNameFlag);
      let companyNameList = val.map((item) => item.companyName).toString();
      if (companyNameList && companyNameList.length > 15) {
        companyNameList = `${companyNameList.substring(0, 14)}...`;
      }
      this.companyIdList = val.map((item) => item.companyId);
      if (this.companyIdList.length > 0) {
        if (this.selectNameFlag === 'purchaseCompanyIdList') {
          this.searchData.purchaseCompanyIdList = companyNameList;
          this.listQuery.purchaseCompanyIdList = this.companyIdList;
          this.purchaseCompanyInfo = val;
        } else if (this.selectNameFlag === 'supplierCompanyIdList') {
          this.searchData.supplierCompanyIdList = companyNameList;
          this.listQuery.supplierCompanyIdList = this.companyIdList;
          this.supplierCompanyInfo = val;
        }
      } else if (this.selectNameFlag === 'purchaseCompanyIdList') {
        this.searchData.data.purchaseCompanyIdList = null;
        this.listQuery.purchaseCompanyIdList = null;
        this.purchaseCompanyInfo = [];
      } else if (this.selectNameFlag === 'supplierCompanyIdList') {
        this.searchData.supplierCompanyIdList = null;
        this.listQuery.supplierCompanyIdList = null;
        this.supplierCompanyInfo = [];
      }
      this.chooseVisible = false;
    },
    // 统一关闭弹框
    closeDialog() {
      this.chooseVisible = false;
    },
    handleFocus(obj) {
      console.log(obj, 'handleFocus');
      if (obj.item === 'purchaseCompanyIdList') {
        this.selectNameFlag = obj.item;
        this.queryPurchaseCompanyVisible = true;
        // this.chooseVisible = true;
      }
    },
    getCreateModeArr(createMode) {
      const { label = '' } = this.createModeArr.find((item) => item.value === createMode) || {};
      return label;
    },
    getCreateSourceArr(createSource) {
      const { label = '' } = this.createSourceArr.find((item) => item.value === createSource) || {};
      return label;
    },
    offerStatusEN(offerStatus) {
      const offerStatusObj = {
        0: '待报价',
        1: '已报价',
        2: '已选入',
        3: '未选入',
        4: '过期',
        5: '作废',
      };
      return offerStatusObj[offerStatus];
    },

    goDetail(row, type) {
      this.rowInfo = { ...row };
      if (type === 1) {
        this.querySupplierListPage(row, type);
      } else if (type === 2) {
        this.queryEnquiryDetailByPage(row, type);
      }
      if (type === 3) {
        this.supplierQuery.supplierDialogTitle = '供应商报价信息';
        this.queryOfferListForAdminByPage(row);
      }
    },
    // 商品信息详情
    async queryEnquiryDetailByPage(row) {
      const params = {
        enquiryId: row.enquiryId,
        pageNum: this.queryEnquiry.pageNum,
        pageSize: this.queryEnquiry.pageSize,
      };
      const res = await Api.queryEnquiryDetailByPage(params);
      if (res.code === '200') {
        this.queryEnquiry.dialogVisible = true;
        this.queryEnquiry.list = res.data.records;
        this.queryEnquiry.total = res.data.total;
      }
    },
    // 报价详情
    async queryOfferListForAdminByPage(row) {
      const params = {
        enquiryId: row.enquiryId,
        purchaseCompanyId: row.purchaseCompanyId,
        pageNum: this.supplierQuery.pageNum,
        pageSize: this.supplierQuery.pageSize,
      };
      const res = await Api.queryOfferListForAdminByPage(params);
      if (res.code == 200) {
        this.supplierQuery.supplierDialogVisible = true;
        this.supplierQuery.list = res.data.records;
        this.supplierQuery.total = res.data.total;
      }
    },

    getProductDetail(row) {
      this.productQuery.enquiryId = row.enquiryId;
      this.productQuery.supplierOfferId = row.supplierOfferId;
      this.querySupplierOfferDetailPage();
    },

    // 定向询价供应商 分页
    async querySupplierListPage(row) {
      const params = {
        enquiryId: row.enquiryId,
        pageNum: this.supplier.pageNum,
        pageSize: this.supplier.pageSize,
      };
      const res = await Api.querySupplierListPage(params);
      if (res.code === '200') {
        this.supplier.dialogVisible = true;
        this.supplier.list = res.data.records;
        this.supplier.total = res.data.total;
      }
    },
    supplierCurrentChange(val) {
      this.supplier.pageNum = val;
      this.querySupplierListPage(this.rowInfo);
    },
    supplierSizeChange(val) {
      this.supplier.pageNum = 1;
      this.supplier.pageSize = val;
      this.querySupplierListPage(this.rowInfo);
    },

    async querySupplierOfferDetailPage() {
      const params = {
        enquiryId: this.productQuery.enquiryId,
        supplierOfferId: this.productQuery.supplierOfferId,
        pageNum: this.productQuery.pageNum,
        pageSize: this.productQuery.pageSize,
      };
      const res = await Api.querySupplierOfferDetailPage(params);
      if (res.code == 200) {
        this.productQuery.productDialogVisible = true;
        this.productQuery.list = res.data.records;
        this.productQuery.total = res.data.total;
      }
    },

    // 获取列表数据
    initData() {
      const params = JSON.parse(JSON.stringify(this.listQuery));
      for (const key in params) {
        if (params[key] === '') {
          params[key] = null;
        }
        if (key == 'enquiryStatusList') {
          if (params[key] && params[key].length == 0) {
            params.enquiryStatusList = null;
          }
        }
        if (key == 'createTime') {
          console.log(params[key], 'createTimecreateTimecreateTimecreateTime');
          if (params[key] == null) {
            params.startTime = null;
            params.endTime = null;
          } else {
            params.startTime = params.createTime[0];
            params.endTime = params.createTime[1];
          }
        }
        if (key == 'inquiryCompletedTime') {
          console.log(params[key], 'inquiryCompletedTimeinquiryCompletedTime');
          if (params[key] == null) {
            params.inquiryCompletedTimeStart = null;
            params.inquiryCompletedTimeEnd = null;
          } else {
            params.inquiryCompletedTimeStart = params.inquiryCompletedTime[0];
            params.inquiryCompletedTimeEnd = params.inquiryCompletedTime[1];
          }
        }
      }
      console.log('params:', params);
      return params;
    },
    async getList() {
      const params = this.initData();
      const { queryEnquiryListReport } = Api;
      this.loading = true;
      const res = await queryEnquiryListReport(params);
      this.loading = false;
      if (res.code === '200') {
        const {
          data: { records = [], total = 0 },
        } = res;
        this.tableData = [...records];
        this.total = total;
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    handleSearch(val) {
      this.listQuery.enquiryNo = val.enquiryNo;
      this.listQuery.enquiryName = val.enquiryName;
      this.listQuery.enquiryType = val.enquiryType;
      this.listQuery.purchaseCompany = val.purchaseCompany;
      this.listQuery.productName = val.productName;
      this.listQuery.enquiryStatusList = val.enquiryStatusList;
      this.listQuery.createMode = val.createMode;
      this.listQuery.createSource = val.createSource;
      this.listQuery.dataFrom = val.dataFrom;
      this.listQuery.isDoC = val.isDoC;
      this.listQuery.shipmentType = val.shipmentType;
      this.listQuery.createTime = val.createTime;
      this.listQuery.inquiryCompletedTime = val.inquiryCompletedTime;
      // this.offerStatusList = val.offerStatusList;

      this.listQuery.pageNum = 1;
      this.getList();
    },
    resetList() {
      this.searchData.purchaseCompanyIdList = '';
      this.searchData.supplierCompanyIdList = '';
      this.listQuery.purchaseCompanyIdList = '';
      this.listQuery.supplierCompanyIdList = '';
      this.companyIdList = [];
      this.purchaseCompanyInfo = [];
      this.supplierCompanyInfo = [];
      this.listQuery = {
        enquiryNo: null,
        enquiryName: null,
        enquiryType: null,
        purchaseCompany: null,
        productName: null,
        enquiryStatusList: [],
        createTime: [],
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
        supplierCompanyIdList: null,
        purchaseCompanyIdList: null,
      };
      /// this.offerStatusList = null;
      this.getList(this.listQuery);
    },

    exportFile(type) {
      const params = this.initData();
      /* if (this.offerStatusList?.length) {
        params.offerStatusList = this.offerStatusList.filter((item) => item !== null);
      } */
      const time = utils.formatDate(new Date(), 'yyyyMMdd');
      const expirtInfo = [
        {
          url: '/transaction-center/EnquiryEnterpriseStatistics/exportEnquiryList',
          name: '询价单信息',
        },
        {
          url: '/transaction-center/EnquiryEnterpriseStatistics/exportEnquiryDetailList',
          name: '询价单商品清单',
        },
        {
          url: '/transaction-center/EnquiryEnterpriseStatistics/exportOfferList',
          name: '供应商报价信息',
        },
        {
          url: '/transaction-center/EnquiryEnterpriseStatistics/exportOfferDetailList',
          name: '供应商报价商品清单',
        },
      ];

      axios({
        url: expirtInfo[type].url,
        method: 'post',
        data: params,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob', // 接收类型设置，否者返回字符型
      }).then((res) => {
        // 定义文件名等相关信息
        console.log(res);

        const resData = res.data;
        const fileReader = new FileReader();
        console.log(resData);

        if (resData.type === 'application/json') {
          // 说明是普通对象数据，读取信息
          this.$message.error('导出上限为50000条，请修改查询条件后重试!');
        } else {
          // 下载文件
          // downloadFile(resData)
          const blob = res.data;
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (e) => {
            console.log('res==>', e);
            const a = document.createElement('a');
            a.download = `${expirtInfo[type].name}_${time}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        }
      });
    },

    handleExport(type) {
      if (type === 2 || type === 3) {
        this.$confirm('仅支持导出询价状态为“询价完成”“订单完成”的供应商报价信息。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.exportFile(type);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消导出',
            });
          });
        return;
      }
      this.exportFile(type);
    },
    supplierQueryCurrentChange(val) {
      this.supplierQuery.pageNum = val;
      this.queryOfferListForAdminByPage(this.rowInfo);
    },
    supplierQuerySizeChange(val) {
      this.supplierQuery.pageNum = 1;
      this.supplierQuery.pageSize = val;
      this.queryOfferListForAdminByPage(this.rowInfo);
    },
    productCurrentChange(val) {
      this.productQuery.pageNum = val;
      this.querySupplierOfferDetailPage();
    },
    productSizeChange(val) {
      this.productQuery.pageNum = 1;
      this.productQuery.pageSize = val;
      this.querySupplierOfferDetailPage();
    },
    queryEnquiryCurrentChange(val) {
      this.queryEnquiry.pageNum = val;
      this.queryEnquiryDetailByPage(this.rowInfo);
    },
    queryEnquirySizeChange(val) {
      this.queryEnquiry.pageNum = 1;
      this.queryEnquiry.pageSize = val;
      this.queryEnquiryDetailByPage(this.rowInfo);
    },
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-btn {
  margin-bottom: 20px;
  justify-content: center;
}
.handle-btn1 {
  margin-bottom: 20px;
  justify-content: flex-start;
}
.handle-btn2 {
  display: flex;
  flex-direction: column;
  align-content: center;
}
.tip {
  color: #f0250f;
  font-size: 12px;
}
</style>
